import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Dimension from "../components/Dimension";
import PageHead from "../components/PageHead";
import { LT_BRAND } from "../data";

function About() {
  const { t } = useTranslation();
  const portrait = process.env.PUBLIC_URL + "/assets/lt.jpg";
  const talk = process.env.PUBLIC_URL + "/assets/talk.jpg";

  const values = t("about.values", { returnObjects: true });
  const valuesArray = Array.isArray(values) ? values : [];

  const facts = [
    ["about.metaFounder", "about.metaFounderVal"],
    ["about.metaFounded", "about.metaFoundedVal"],
    ["about.metaLocation", "about.metaLocationVal"],
    ["about.metaFocus", "about.metaFocusVal"],
    ["about.metaBackground", "about.metaBackgroundVal"],
    ["about.metaTeaching", "about.metaTeachingVal"],
    ["about.metaResearch", "about.metaResearchVal"],
  ];

  return (
    <div className="container">
      <Seo page="about" path="/about" />

      <PageHead title={t("about.heroTitle")} lede={t("about.heroDesc")} />

      <div className="band">
        <Dimension label={t("dimension.facts", { n: facts.length + 1 })} />
      </div>

      <section className="about-grid">
        <dl className="deflist">
          {facts.map(([k, v]) => (
            <React.Fragment key={k}>
              <dt>{t(k)}</dt>
              <dd>{t(v)}</dd>
            </React.Fragment>
          ))}
          <dt>{t("about.metaGithub")}</dt>
          <dd>
            <a
              className="link"
              href={LT_BRAND.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              louistrue
            </a>
          </dd>
        </dl>

        <div className="prose">
          <h2>{t("about.bodyTitle1")}</h2>
          <p>{t("about.bodyP1")}</p>
          <p>{t("about.bodyP2")}</p>
          <h2>{t("about.bodyTitle3")}</h2>
          <p>{t("about.bodyP4")}</p>
          <h2>{t("about.bodyTitle4")}</h2>
          <p>{t("about.bodyP5")}</p>
        </div>
      </section>

      <div className="band">
        <Dimension label={t("dimension.portraits", { n: 2 })} />
      </div>
      <div className="portraits">
        <figure>
          <img src={portrait} alt={t("about.portrait1")} />
          <Dimension label={t("about.portrait1")} />
        </figure>
        <figure>
          <img src={talk} alt={t("about.portrait2")} />
          <Dimension label={t("about.portrait2")} />
        </figure>
      </div>

      <div className="band">
        <Dimension
          label={t("dimension.principles", { n: valuesArray.length })}
        />
      </div>
      <h2 className="h-section">{t("about.principlesTitle")}</h2>
      <div className="col2 values band-bottom">
        {valuesArray.map((v) => (
          <div key={v.title}>
            <h3>{v.title}</h3>
            <p>{v.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default About;
